var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 26,
    viewBox: "0 0 29 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20880"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5901 0.270121C15.6554 -0.364684 18.8471 0.127963 21.5784 1.65758C24.3097 3.18718 26.3973 5.651 27.4576 8.5964C28.5181 11.5419 28.4801 14.7709 27.3506 17.6905C26.221 20.6101 24.076 23.0241 21.3093 24.4889L20.847 23.6158L21.3093 24.4889C18.5427 25.9538 15.3405 26.3711 12.2909 25.6642C9.24126 24.9574 6.54913 23.1738 4.70909 20.6412C4.38446 20.1944 4.4835 19.569 4.9303 19.2444C5.37711 18.9198 6.00248 19.0188 6.32711 19.4656C7.88408 21.6086 10.162 23.1178 12.7425 23.7159C15.323 24.314 18.0325 23.9609 20.3734 22.7214L20.3735 22.7213C22.7145 21.4819 24.5295 19.4394 25.4853 16.9689C26.441 14.4985 26.4732 11.7662 25.5759 9.2739L25.5759 9.27386C24.6787 6.78163 22.9123 4.69685 20.6012 3.40257C18.2901 2.10828 15.5894 1.69142 12.9956 2.22857C10.4018 2.76572 8.08894 4.22081 6.48193 6.32651L5.76542 5.7797L6.48192 6.32651C5.3808 7.76932 4.66176 9.45119 4.37167 11.2175L4.79288 10.7963C5.18341 10.4058 5.81657 10.4058 6.2071 10.7963C6.59762 11.1868 6.59762 11.82 6.2071 12.2105L3.9571 14.4605C3.56658 14.8511 2.93341 14.8511 2.54289 14.4605L0.292893 12.2105C-0.0976311 11.82 -0.0976311 11.1868 0.292893 10.7963C0.683417 10.4058 1.31658 10.4058 1.70711 10.7963L2.32354 11.4128C2.60361 9.13628 3.48321 6.95914 4.89204 5.11315C6.79123 2.6246 9.52464 0.904943 12.5901 0.270122L12.7714 1.14596L12.5901 0.270121Z",
    fill: "#8D90A5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2262 6C15.7785 6 16.2262 6.44772 16.2262 7V12.5858L20.4333 16.7929C20.8238 17.1834 20.8238 17.8166 20.4333 18.2071C20.0428 18.5976 19.4096 18.5976 19.0191 18.2071L14.5191 13.7071C14.3316 13.5196 14.2262 13.2652 14.2262 13V7C14.2262 6.44772 14.6739 6 15.2262 6Z",
    fill: "#8D90A5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsIcon);
export default __webpack_public_path__ + "static/media/logsIcon.ab54bd9e08f5cb36bbe05d91b92abccc.svg";
export { ForwardRef as ReactComponent };